module.exports = __webpack_public_path__ + "img/model-heard.ea55a8f9.png";